define.alias("shared/components/shared/post/profile-selector/profile-list", "media/components/shared/post/profile-selector/profile-list/index");